import * as React from "react";
import classnames from "classnames";
/* empty css                      */
function CardButtonLayout({ children, className, ...rest }) {
  return /* @__PURE__ */ React.createElement("div", { className: classnames("card-button-layout", className), ...rest }, children);
}
export {
  CardButtonLayout as default
};
//# sourceMappingURL=CardButtonLayout.js.map
